var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 7,
    height: 31,
    rx: 3.5,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 2,
    width: 7,
    height: 31,
    rx: 3.5,
    fill: "#fff"
  })));
}
export default SvgPauseIc;